import { useState, useEffect } from 'react';
import Api from 'entities/helpers/api';

const PROPOSAL_FETCH_LIMIT = 100;

/**
 * Fetches real proposals from the search API.
 * Used by cadence, prospect plan, and bulk message creation pages for proposal linking.
 *
 * @param {string} [search] - Already-debounced search text. When provided,
 *   queries the backend for a title match (NEXDEV-2120) instead of only
 *   returning the default alphabetical browse — a fixed window can never
 *   cover every org's proposals, so search must hit the server.
 */
const useProposals = (search = '') => {
  const [proposals, setProposals] = useState([]);
  useEffect(() => {
    const trimmed = search.trim();
    Api.SEARCH.PROPOSAL.post({
      params: { limit: PROPOSAL_FETCH_LIMIT, offset: 0 },
      data: JSON.stringify({
        must: trimmed ? [{ title: { wildcard: `*${trimmed}*` } }] : [],
        sort: [{ title: { order: 'asc' } }],
      }),
    })
      .then((resp) => {
        const items = (resp?.items || []).map((item) => ({
          label: item.title || item.name || item.label || `Proposal ${item.id}`,
          value: String(item.id),
        }));
        setProposals(items);
      })
      .catch(() => setProposals([]));
  }, [search]);
  return proposals;
};

export default useProposals;
